import React from 'react';
import {HashRouter as Router, Route, Routes} from "react-router-dom";
import Base from "./pages/Base";
import Settings from "./pages/Settings";
import Logs from "./pages/Logs"
import ArchivedOrder from "./pages/ArchivedOrder"
import HelpDocumentation from "./pages/HelpDocumentation"

const App = () =>{
    return(
        <Router>
            <Routes>
                <Route path="/" element={<Base/>}>
                    <Route index element={<Settings/>} />
                    <Route path="logs" element={<Logs/>}/>
                    <Route path="/logs/page/:page" element={<Logs/>} />
                    <Route path="archived-order" element={<ArchivedOrder/>}/>
                    <Route path="help-documentation" element={<HelpDocumentation/>}/>
                </Route>
            </Routes>
        </Router>
    )
}

export default App;